import { useApiFetch } from "@cheatsheetz/sheetz-core/providers/CheatsheetzFetchProvider";
import { useQuery } from "@tanstack/react-query";
import type { UserSettings } from "./useUpdateUserSettings";

export const userSettingsQueryKeys = {
  all: ["userSettings"] as const,
};

/**
 * Query hook that fetches the authenticated user's display settings
 * from the API. Returns an empty object when no settings are saved yet.
 *
 * The query is only enabled when the user is authenticated (`enabled` flag).
 */
export function useUserSettings(enabled: boolean) {
  const apiFetch = useApiFetch();

  return useQuery<UserSettings>({
    queryKey: userSettingsQueryKeys.all,
    queryFn: async () => {
      const result = await apiFetch<UserSettings>("/api/account/settings");

      if (!result.completed || !result.response.success) {
        return {};
      }

      return result.response.data ?? {};
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
